import crossfilter from "crossfilter2";

const dataAccessor = function(data) {
  let _this = this;
  _this.cache = {};

  data = data.map(function(d, i) {
    return { ...d, RECORDID: i + 1 };
  });

  _this.data = crossfilter(data);

  // ---- Formatted data for a question, grouped
  // ---- @param {Number} id
  // ---- @param {Object} (Optional) filters
  // ---- @return {Object} results

  _this.get = function(id, filters) {
    let dimensions = [],
      results = {};

    // If the current id isn't cached
    // Cache the id
    // Dispose the primary dimension if it exists
    // Query all data associated with the id
    // Count, group, deep copy, and add to results

    if (_this.cache.id === undefined || id !== _this.cache.id) {
      _this.cache.id = id;

      if (_this.cache.results !== undefined) {
        _this.cache.results.dispose();
      }
      _this.cache.results = _this.data.dimension(function(d) {
        return d[_this.cache.id];
      });
    }
    results.all = {
      count: _this.data.size(),
      weight: _this.data
        .groupAll()
        .reduceSum(function(d) {
          return d["WT"];
        })
        .value(),
      data: JSON.parse(
        JSON.stringify(
          _this.cache.results
            .group()
            .reduceSum(function(d) {
              return d["WT"];
            })
            .all()
        )
      ),
    };

    // If filters exist
    // Loop through each
    // Create a temporary dimension of the dataset
    // Filter against the array of possible values
    // Add temporary dimension to reference array
    // Count, group, deep copy, and add to results

    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        let filterDimension = _this.data.dimension(function(d) {
          return d[filters[i].dimension];
        });
        filterDimension.filter(function(d) {
          return filters[i].value.indexOf(+d) > -1;
        });
        dimensions.push(filterDimension);
      }

      const unfiltered = data.map((d) => {
        return { [d.RECORDID]: { value: d[id], filtered: false } };
      });

      const filtered = _this.cache.results.top(Infinity).map((d) => {
        return { [d.RECORDID]: { value: d[id], filtered: true } };
      });

      const combined = Object.entries(
        Object.assign({}, ...unfiltered, ...filtered)
      ).map(([key, value]) => value);

      results.filtered = {
        count: _this.cache.results.top(Infinity).length,
        weight: _this.cache.results
          .groupAll()
          .reduceSum(function(d) {
            return d["WT"];
          })
          .value(),
        weightByKey: JSON.parse(
          JSON.stringify(
            _this.cache.results
              .group()
              .reduceSum(function(d) {
                return d["WT"];
              })
              .all()
          )
        ),
        data: combined,
      };
    }

    // Dispose of temporary dimensions to free up space
    // Send over formatted results

    for (let i = 0; i < dimensions.length; i++) {
      dimensions[i].dispose();
    }
    return results;
  };
};

export default dataAccessor;
